import Modal from "react-modal";

export const PdfExportWarningModal = ({ actions, ctx, uiState }) => {

  const { onClose } = actions || {};
  const { missingCount, total } = ctx || {};
  const { isOpen } = uiState || {};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 20000,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          padding: "1rem",
          textAlign: "center",
          borderRadius: "8px",
          blockSize: "auto",
          overflow: 'scroll',
          maxWidth: 420,
        }
      }}
      contentLabel="Aviso de exportação"
    >
      <div style={{ inlineSize: '100%' }}>
        <h2 style={{ color: "#e75d0d", marginBottom: "1rem" }}>
          PDF gerado com pendências
        </h2>

        <p style={{ fontSize: "1rem", color: "#333", marginBottom: "1rem" }}>
          {`O download foi concluído, mas ${missingCount} de ${total} produto${missingCount === 1 ? '' : 's'} não ${missingCount === 1 ? 'teve imagem encontrada' : 'tiveram imagem encontrada'}. Esses itens aparecem no PDF sem foto.`}
        </p>

        <button
          onClick={onClose}
          style={{
            marginTop: "1.5rem",
            padding: "0.5rem 1.5rem",
            backgroundColor: "#e75d0d",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "1rem",
          }}
        >
          Fechar
        </button>
      </div>
    </Modal>
  );
};